module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SquadDetail ListingCard-item"
  }, [(_vm.squad.name) ? _c('h3', {
    staticClass: "ListingCard-title"
  }, [_vm._v("\n    " + _vm._s(_vm.squad.name) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "u-mb1"
  }, [(_vm.squad.zip) ? _c('span', [_vm._v("Zip Code: " + _vm._s(_vm.squad.zip))]) : _vm._e(), _vm._v(" "), (_vm.squad.district_id) ? _c('span', {
    staticClass: "SquadDetail-text"
  }, [_vm._v("\n      District: " + _vm._s(_vm.squad.district_name) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "SquadDetail-text"
  }, [_vm._v("\n      Squad Leader: " + _vm._s(_vm.squad.firstName) + " " + _vm._s(_vm.squad.lastName) + "\n    ")]), _vm._v(" "), (_vm.squad.website) ? _c('span', {
    staticClass: "SquadDetail-text"
  }, [_vm._v("\n      Website: " + _vm._s(_vm.squad.website) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.squad.distance) ? _c('span', {
    staticClass: "SquadDetail-text"
  }, [_vm._v("\n      Distance: " + _vm._s(_vm.squad.distance) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "Button Button--outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.joinSquad(_vm.squad)
      }
    }
  }, [_vm._v("\n    Join This Squad\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70e93458","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/squad-listing-item.vue
// module id = 341
// module chunks = 0